import styled from "styled-components";
import { theme } from "../../../constants/StyledComponents";
import { TooltipOpenModeEnum } from "./Tooltip";

export const ChildrenContainer = styled.div<{
  $openMode?: TooltipOpenModeEnum;
}>`
  position: relative;
  display: inline-block;
  cursor: ${(props) =>
    props.$openMode === TooltipOpenModeEnum.CLICK && "pointer"};
`;

export enum TooltipVariantEnum {
  DEFAULT = "default",
  DARK = "dark",
}

export enum TooltipPositionEnum {
  TOP = "top",
  RIGHT = "right",
  BOTTOM = "bottom",
}

const tooltipColors = {
  [TooltipVariantEnum.DEFAULT]: {
    background: theme.colors.grey_6,
  },
  [TooltipVariantEnum.DARK]: {
    background: theme.colors.black,
  },
};

export const StyledTooltip = styled.div<{
  $top: number;
  $left: number;
  $width?: number;
  $variant?: TooltipVariantEnum;
  $position?: TooltipPositionEnum;
  $autoWidth?: boolean;
}>`
  min-width: ${(props) =>
    props.$width ? "unset" : props.$autoWidth ? "unset" : "200px"};
  width: ${(props) =>
    props.$width
      ? `${props.$width}px`
      : props.$autoWidth
        ? "max-content"
        : "unset"};
  white-space: ${(props) => (props.$autoWidth ? "nowrap" : "normal")};
  position: absolute;
  max-width: calc(100vw - 48px);
  cursor: default;
  background-color: ${({ $variant }) =>
    tooltipColors[$variant ?? TooltipVariantEnum.DEFAULT].background};
  padding: 12px;
  border-radius: 6px;
  box-shadow: 0px 2px 8px 0px ${theme.colors.grey_1}33;
  z-index: 9999;
  top: ${(props) => props.$top}px;
  left: ${(props) => props.$left}px;
  transform: ${({ $position }) =>
    $position === TooltipPositionEnum.RIGHT
      ? "translateY(0)"
      : "translateX(-50%)"};

  & > p {
    margin: 5px;
  }
`;

export const TooltipArrow = styled.div<{
  $variant?: TooltipVariantEnum;
  $position?: TooltipPositionEnum;
}>`
  position: absolute;
  width: 15px;
  height: 15px;
  background-color: ${({ $variant }) =>
    tooltipColors[$variant ?? TooltipVariantEnum.DEFAULT].background};
  box-shadow: 3px 3px 3px -2px ${theme.colors.grey_1}33;
  ${({ $position }) =>
    $position === TooltipPositionEnum.RIGHT
      ? `
    left: -7px;
    top: calc(50% - 7.5px);
    transform: rotateZ(45deg);
  `
      : $position === TooltipPositionEnum.BOTTOM
        ? `
    box-shadow: -3px -3px 3px -2px ${theme.colors.grey_1}33;
    left: calc(50% - 7.5px);
    top: -7px;
    transform: rotateZ(45deg);
  `
        : `
    left: calc(50% - 7.5px);
    bottom: -7px;
    transform: rotateZ(45deg);
  `}
`;
